import React from 'react';
import ScheduleSelector from './schedule-selector';
import RecurUntilSelector from './recur-until-selector';
function Recurrence() {
    return (React.createElement("div", { className: "recurrence" },
        React.createElement(ScheduleSelector, null),
        React.createElement(RecurUntilSelector, null)));
}
export default Recurrence;
